<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>EXTENSIBILITY</div>
				<h2 waHeading="l" waText>SPI-Driven Extension Points</h2>
				<p waBody="m" waColorText="quiet" waText>Implement an interface. Register it. Done.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>JWebMP is designed around SPI contracts. Every extension point &mdash; pages, configurators, events, render hooks, interceptors &mdash; is a ServiceLoader interface. Register your implementation in module-info.java or META-INF/services, and the framework picks it up at startup. No reflection hacks, no classpath scanning.</p>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Extend with a Page Configurator</div>
					<markdown [data]="mdContent_27" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Register in module-info.java</div>
					<markdown [data]="mdContent_28" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
			</div>
		</div>
	</div>
</div>